import { useContext, useState } from "react";
import { wsDeleteOrdenEstudio } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { wsDeleteOrdenLaboratorio } from "_+_Portal/context/Actions/ordenLaboratorio/ordenLaboratorio";
import { PortalContext } from "_+_Portal/context/Provider";
import { ContainerEditarOrden, Img, Point } from "./localStyle";
import FlechaCircleIcon from "_+_Portal/assets/images/generico/FlechaCircleIcon";
// deb
const ConfirmImage = ({
  image,
  setIndex,
  index,
  imageMod,
  setImageMod,
  listImagenes,
  idProtocolo,
  idturno,
  dissmiss,
  listImage,
}) => {
  //#region  ----------- useState ---------------
  const [loading, setLoading] = useState(false);
  const [imageCarrousel, setImageCarrousel] = useState(0);
  //#endregion  -------- useState ---------------

  //#region  ----------- context ---------------
  const { ordenEstudioDispatch, ordenLaboratorioDispatch } =
    useContext(PortalContext);
  //#endregion  -------- context ---------------

  //#region  ----------- context ---------------
  const elemento = listImagenes[index];
  //#endregion  -------- context ---------------

  //#region  ----------- funtions ---------------
  const nextStep = () => {
    setLoading(false);
    setImageMod(imageMod + 1);
    if (listImagenes[index + 1]) {
      setIndex(index + 1);
    } else {
      setIndex(-1);
    }
  };

  const success = () => {
    setLoading(true);
    if (idProtocolo) {
      wsDeleteOrdenLaboratorio(
        idProtocolo,
        elemento.idRemoto,
        nextStep
      )(ordenLaboratorioDispatch);
    } else if (idturno) {
      wsDeleteOrdenEstudio(
        idturno,
        elemento.idRemoto,
        nextStep
      )(ordenEstudioDispatch);
    }
  };
  const fail = () => {
    if (listImagenes[index + 1]) {
      setIndex(index + 1);
    } else {
      if (!imageMod) {
        dissmiss();
      }
      setIndex(-1);
    }
  };
  const changeImage = (siguiente) => {
    const totalImages = listImage.length;
    if (siguiente) {
      setImageCarrousel((imageCarrousel + 1) % totalImages);
    } else {
      setImageCarrousel((imageCarrousel - 1 + totalImages) % totalImages);
    }
  };
  //#endregion  -------- funtions ---------------

  //#region  ----------- useEffect ---------------
  //#endregion  -------- useEffect ---------------

  return (
    <ContainerEditarOrden>
      <span>¿Desea eliminar todos los archivos?</span>
      <div className="container-carrousel">
        <div className="img-container">
          {listImage.map((e, key) => {
            if (imageCarrousel === key) {
              return (
                <Img
                  active={imageCarrousel === key}
                  src={`data:image/png;base64,${listImage[key].binario}`}
                  alt="archivo de orden"
                  key={key}
                />
              );
            }
          })}
        </div>
        <div className="container-point">
          {listImage.map((e, key) => (
            <Point
              key={key}
              className="point"
              active={imageCarrousel !== key}
            ></Point>
          ))}
        </div>
        <div className="container-flechas">
          <div
            className="flechaBtn flechaInvertida"
            onClick={() => changeImage(false)}
          >
            <FlechaCircleIcon />
          </div>
          <div className="flechaBtn" onClick={() => changeImage(true)}>
            <FlechaCircleIcon />
          </div>
        </div>
      </div>
    </ContainerEditarOrden>
  );
};

export default ConfirmImage;
